import React, { useRef } from 'react';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import PropTypes from 'prop-types';
import Tooltip from 'cccisd-tooltip';
import notification from 'cccisd-notification';

import CareCoordinatorForm from '../../../../components/Manage/CareCoordinatorForm';

import IconPencil from 'cccisd-icons/pencil';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const EditCareCoordinatorForm = props => {
    const modal = useRef();
    const { row, loadData } = props;

    const onSubmit = async values => {
        const hasSupervisor = !!values.supervisor;

        const response = await axios.put(
            Boilerplate.route('api.nexus.pawn.update', {
                pawn: row['pawn.pawnId'],
            }),
            {
                pawnHash: row['pawn.pawnHash'],
                role: 'careCoordinator',
                first_name: values.firstName,
                last_name: values.lastName,
                group: values.site,
                parentPawns: hasSupervisor ? JSON.stringify([values.supervisor]) : JSON.stringify([]),
                managePageAccess: values.managePageAccess,
                dashboardPageAccess: values.dashboardPageAccess,
                administerPageAccess: values.administerPageAccess,
                receiveAlertsImmediately: hasSupervisor ? values.receiveAlertsImmediately : false,
                receiveAlertsDigest: hasSupervisor ? values.receiveAlertsDigest : false,
                receiveNotifications: hasSupervisor ? values.receiveNotifications : false,
            }
        );

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ message: errorMessage, type: 'danger' });
            return Promise.reject(response.data.errors);
        }

        await loadData();
        notification('Care Coordinator updated.');
        await modal.current.close();
    };

    const supervisorPawnId = row['parentRoles.supervisor.pawn.pawnId'];

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title="Edit Care Coordinator"
            size="large"
        >
            <CareCoordinatorForm
                onSubmit={onSubmit}
                disableUsername
                initialValues={{
                    username: row['user.username'],
                    firstName: row['user.firstName'],
                    lastName: row['user.lastName'],
                    site: row['parentGroup.site.group.groupId'] ? [row['parentGroup.site.group.groupId']] : [],
                    supervisor: supervisorPawnId ? String(supervisorPawnId) : '',
                    managePageAccess: row['fields.managePageAccess'] !== null ? !!row['fields.managePageAccess'] : true,
                    dashboardPageAccess:
                        row['fields.dashboardPageAccess'] !== null ? !!row['fields.dashboardPageAccess'] : true,
                    administerPageAccess:
                        row['fields.administerPageAccess'] !== null ? !!row['fields.administerPageAccess'] : true,
                    receiveAlertsImmediately: !!row['fields.receiveAlertsImmediately'],
                    receiveAlertsDigest: !!row['fields.receiveAlertsDigest'],
                    receiveNotifications: !!row['fields.receiveNotifications'],
                }}
            />
        </Modal>
    );
};

EditCareCoordinatorForm.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditCareCoordinatorForm;
